module.exports = __webpack_public_path__ + "img/template202009021.61a79171.png";